import React, { useState, useEffect, useRef } from "react";
import Leftbar from "../../components/Leftsidebar";
import Topbar from "../../components/Topbar";
import { Link } from "react-router-dom";
import "../Projects/project.css";
import { deleteProject, resetProjectFunding, handleProjectlist, uploadProjectToMultimodal, getMultimodalStatus, getMultimodalDownloadUrl } from '../Utils/utils';
import ReactPaginate from 'react-paginate';
import { Col, Row } from 'react-bootstrap';
import moment from 'moment';
import Loaderspinner from "../../components/Loader";
import { handleExportProjectlist, showToast, usTimezone } from "../Utils/utils";
import { Tooltip } from 'react-tooltip'
import SweetAlert from "react-bootstrap-sweetalert";
import CommissionBadge from "../../components/CommissionBadge";

const MULTIMODAL_TERMINAL_STATUSES = ['succeeded', 'failure', 'cancelled'];
const isMultimodalTerminal = (executions) => (
  executions.length > 0 && executions.every((e) => MULTIMODAL_TERMINAL_STATUSES.includes(e.execution_status))
);

const ProjectList = () => {
  const [showSidebar, setShowSidebar] = useState(false);
  const [typeStatus, setTypeStatus] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false)
  const [showAlert, setShowAlert] = useState(false);
  const [proId, setProId] = useState('');
  const [resetProId, setResetProId] = useState('');
  const [resetProStatus, setResetProStatus] = useState('');
  const [search, setSearch] = useState("");
  const [multimodalStatus, setMultimodalStatus] = useState({});
  const [multimodalUploadingId, setMultimodalUploadingId] = useState(null);
  // Mirrors multimodalStatus so the polling interval below always reads
  // the latest value without needing to be torn down/recreated on every
  // status update (it only depends on projectList).
  const multimodalStatusRef = useRef(multimodalStatus);
  useEffect(() => {
    multimodalStatusRef.current = multimodalStatus;
  }, [multimodalStatus]);

  const role = localStorage.getItem("role")

  const handleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  const handleSidebarClose = () => {
    setShowSidebar(false);
  };

  useEffect(() => {

    if (search.length == 0 || search.length >= 3) {

      fetchRaisers();
    }
  }, [typeStatus, page, search]);

  const fetchRaisers = async () => {
    try {
      setLoading(true)
      const token = localStorage.getItem("token");
      const limit = 10;
      const offset = page * limit;

      const response = await handleProjectlist({
        type: typeStatus,
        limit,
        offset,
        token, search
      });

      setProjectList(response?.data || []);

      if ((response?.data?.length || 0) < limit) {
        setTotalPages(page + 1);
      } else {
        setTotalPages(page + 2);
      }

    } catch (error) {
      console.error("Error fetching lenders:", error);
    } finally {
      setLoading(false)
    }
  };

  // Multimodal: fetch current execution status for every project on the
  // page. Called on load, and repeated on an interval only while at
  // least one project still has a non-terminal execution.
  const fetchMultimodalStatuses = async (projects) => {
    const entries = await Promise.all(projects.map(async (project) => {
      try {
        const response = await getMultimodalStatus(project.id);
        return [project.id, response?.data?.executions || []];
      } catch (error) {
        return [project.id, []];
      }
    }));
    setMultimodalStatus((prev) => ({ ...prev, ...Object.fromEntries(entries) }));
  };

  useEffect(() => {
    if (projectList.length === 0) return;
    fetchMultimodalStatuses(projectList);

    const interval = setInterval(() => {
      const stillPending = projectList.filter((project) => {
        const executions = multimodalStatusRef.current[project.id] || [];
        return executions.length > 0 && !isMultimodalTerminal(executions);
      });
      if (stillPending.length > 0) fetchMultimodalStatuses(stillPending);
    }, 60000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectList]);

  const handleMultimodalUpload = async (projectId) => {
    try {
      setMultimodalUploadingId(projectId);
      await uploadProjectToMultimodal(projectId);
      showToast("Submitted to Multimodal.", "success");
      await fetchMultimodalStatuses([{ id: projectId }]);
    } catch (error) {
      showToast(error.message || "Multimodal upload failed", "error");
    } finally {
      setMultimodalUploadingId(null);
    }
  };

  const handleMultimodalDownload = async (executionId, downloadKey) => {
    try {
      const response = await getMultimodalDownloadUrl(executionId, downloadKey);
      const url = response?.data?.url || response?.data?.download_url;
      if (url) {
        window.open(url, "_blank");
      } else {
        showToast("No download URL returned.", "error");
      }
    } catch (error) {
      showToast(error.message || "Failed to get download link", "error");
    }
  };

  const ExportProjectList = async () => {
    try {
      setLoading(true);

      const response = await handleExportProjectlist({
        funding_status: typeStatus,
      });

      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "project_list.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error("Export failed:", error);
      showToast(error.message || "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };


  const handleDelete = async () => {
    var res = await deleteProject(proId)
    if (res.status == 200) {

      showToast("Deleted successfully", "success");
      fetchRaisers();
    }
    setShowAlert(false);
  };

  const handleResetFunding = async () => {
    const id = resetProId;
    setResetProId('');
    try {
      const res = await resetProjectFunding(id);
      if (res.status == 200) {
        showToast("Project funding reset successfully", "success");
        fetchRaisers();
      }
    } catch (error) {
      showToast(error?.message || "Something went wrong", "error");
    }
  };

  return (
    <>
      {loading && <Loaderspinner />}
      <div class="g-sidenav-show  bg-gray-100">
        <div id="wrapper">
          <Leftbar showSidebar={showSidebar}
            handleSidebarClose={handleSidebarClose} />
          <main className="main-content border-radius-lg">
            <Topbar handleSidebar={handleSidebar} />

            <div className="header header-bg pb-6">
              <div className="container-fluid">
                <div className="header-body">
                  <div className="row align-items-center py-4">
                    <div className="col-lg-6 col-7">
                      <nav
                        aria-label="breadcrumb"
                        className="d-none d-md-inline-block ml-md-4"
                      >
                        <ol className="breadcrumb breadcrumb-links breadcrumb-dark" style={{ background: "transparent" }}>
                          <li className="breadcrumb-item">
                            <Link to="/dashboard">
                              <i className="fas fa-home" />
                            </Link>
                          </li>
                          <li className="breadcrumb-item mt-2">
                            <span className="" style={{ color: "#f6f9fc" }}>Projects</span>
                          </li>
                        </ol>
                      </nav>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="container-fluid mt--6">
              <div className="row">
                <div className="col">
                  <div className="card">
                    <div className="card-header border-0">
                      <div className="d-flex justify-content-between">
                        <div className="row ">
                          <h5 className="mb-0 w-auto">Projects</h5>
                          <p
                            className="w-auto px-0"
                            data-tooltip-id="my-tooltip"
                            data-tooltip-content="A complete list of all projects created by borrowers. Use this report to review project details, check status, and ensure projects comply with platform guidelines."
                            data-tooltip-place="right"
                          >
                            <i className="fas fa-info-circle" />

                          </p>

                          <Tooltip id="my-tooltip" style={{ width: '30%' }} />
                        </div>
                        <div>
                          <input
                            type="text"
                            className="search-input mx-2"
                            placeholder="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                          />
                          <select
                            className="custom-select-dropdown font-bold"
                            value={typeStatus}
                            onChange={(e) => setTypeStatus(e.target.value)}
                          >
                            <option value="" className='option'>Funding Status</option>
                            <option value="funding_requested" className='option'>Funding Offered</option>
                            <option value="funding_approved" className='option'>Funding Offer Accepted </option>
                            <option value="funding_secured" className='option'>Funding Accepted</option>
                            <option value="funding_cancelled" className='option'>Admin Fee Not Paid</option>
                          </select>
                          <button className='export-btn ml-0 ml-lg-3 mt-3 mt-lg-0 mx-2' onClick={ExportProjectList}><span>Export Projects</span></button>
                        </div>
                      </div>
                    </div>
                    <div className="table-responsive">
                      <table className="table align-items-center table-flush">
                        <thead className="thead-light">
                          <tr>
                            <th>Action</th>
                            <th>Project Name</th>
                            <th>Created At</th>
                            <th>Capital Partner</th>
                            <th>Borrower</th>
                            <th>Lender</th>
                            <th>Location</th>
                            <th>Status</th>
                            <th>Commission</th>
                            <th>Multimodal</th>
                          </tr>
                        </thead>
                        <tbody>
                          {projectList?.length > 0 ? (
                            projectList.map((project, index) => (
                              <tr key={index}>
                                <td>
                                  <div style={{ width: "120px" }}>
                                    <Link to={`/view-project/${project?.id}`} target="_blank">
                                      <button className="viewproject-btn pull-right mb-1">
                                        <span className="text-white">View Project</span>
                                      </button>
                                    </Link>
                                    {(project?.status === "funding_cancelled" || project?.status === "funding_secured") && (role === "super_admin" || role === "admin") &&
                                      <button className="viewproject-btn pull-right mb-1"
                                        onClick={() => {
                                          setResetProId(project?.id)
                                          setResetProStatus(project?.status)
                                        }}
                                      >
                                        <span className="text-white">Reset Project</span>
                                      </button>
                                    }
                                    {role !== "virtual_assistant" &&
                                      <>
                                        <button className="viewproject-btn pull-right mb-1"
                                          onClick={() => {
                                            setProId(project?.id)
                                            setShowAlert(true)
                                          }}
                                        >
                                          <span className="text-white">Delete</span>
                                        </button>
                                      </>
                                    }
                                  </div>
                                </td>
                                <td className="table-user">
                                  <div style={{ width: "180px", whiteSpace: "collapse" }}>
                                    <span>{project?.project_name}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div style={{ width: "120px" }}><span>{project?.created_at ? usTimezone(project.created_at) : ' '}</span></div>
                                </td>

                                <td className="table-user">
                                  {project?.capital_partner === "MultiFamily" ?
                                    <div style={{ width: "120px" }}>
                                      <span>Multi Family</span>
                                    </div> : project?.capital_partner === "SingleFamily" ?

                                      <div style={{ width: "120px" }}>
                                        <span>Single Family</span>
                                      </div> :
                                      <div style={{ width: "120px" }}>
                                        <span>{project?.capital_partner ? project?.capital_partner : ""}</span>
                                      </div>
                                  }

                                </td>
                                <td>
                                  <div style={{ width: "130px" }}>
                                    <span>{project?.user ?
                                      `${project?.user?.about?.name} ${project?.user?.about?.lastname}`
                                      : "-"}</span>
                                  </div>
                                </td>
                                <td>
                                  <div style={{ width: "130px" }}>
                                    <span>{project?.funder ?
                                      `${project?.funder?.about?.name} ${project?.funder?.about?.lastname}`
                                      : "-"}</span>
                                  </div>
                                </td>

                                <td className="table-user">
                                  <div style={{ width: "220px", whiteSpace: "collapse" }}>
                                    <div className="">{project?.location ? project?.location : " "} {project?.city} </div>
                                  </div>
                                </td>
                                <td>
                                  {project?.status === "funding_requested" && (
                                    <div className="project-status p-1" >
                                      <span className="text-white d-flex justify-content-center">Funding Offered</span>
                                    </div>
                                  )}

                                  {project?.status === "funding_secured" && (
                                    <div className="project-status p-1" >
                                      <span className="text-white d-flex justify-content-center">Funding Accepted</span>
                                    </div>
                                  )}

                                  {(project?.status === "funding_approve" || project?.status === "funding_approved") && (
                                    <div className="project-status p-1">
                                      <span className="text-white d-flex justify-content-center">Funding Offer Accepted </span>
                                    </div>
                                  )}

                                  {/* funding_cancelled = borrower did not pay the admin fee after the match was approved */}
                                  {project?.status === "funding_cancelled" && (
                                    <div style={{ width: "150px" }}>
                                      <div className="project-status p-1">
                                        <span className="text-white d-flex justify-content-center">Funding Offer Accepted </span>
                                      </div>
                                      <div className="project-status-sub">Admin Fee Not Paid</div>
                                    </div>
                                  )}
                                </td>

                                <td>
                                  <div style={{ width: "130px" }}>
                                    <CommissionBadge status={project?.commission_status} amount={project?.commission_amount} required={project?.commission_required} />
                                  </div>
                                </td>

                                <td>
                                  <div style={{ width: "140px" }}>
                                    {(() => {
                                      const executions = multimodalStatus[project.id] || [];

                                      if (executions.length === 0) {
                                        return (
                                          <button
                                            className="viewproject-btn mb-1"
                                            disabled={multimodalUploadingId === project.id}
                                            onClick={() => handleMultimodalUpload(project.id)}
                                          >
                                            <span className="text-white">
                                              {multimodalUploadingId === project.id ? "Uploading..." : "Upload"}
                                            </span>
                                          </button>
                                        );
                                      }

                                      if (!isMultimodalTerminal(executions)) {
                                        return <span>In progress ({executions.length} file{executions.length > 1 ? "s" : ""})</span>;
                                      }

                                      const succeeded = executions.filter((e) => e.execution_status === "succeeded");
                                      const failed = executions.filter((e) => e.failed);

                                      return (
                                        <>
                                          {failed.length > 0 && (
                                            <div><span className="text-danger">{failed.length} failed</span></div>
                                          )}
                                          {succeeded.map((e) => {
                                            const key = e.report_pdf_download_key || e.report_markdown_download_key;
                                            if (!key) return null;
                                            return (
                                              <button
                                                key={e.execution_id}
                                                className="viewproject-btn mb-1"
                                                onClick={() => handleMultimodalDownload(e.execution_id, key)}
                                              >
                                                <span className="text-white">Download Report</span>
                                              </button>
                                            );
                                          })}
                                        </>
                                      );
                                    })()}
                                  </div>
                                </td>

                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="11" className="text-center"><b>No records found</b></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <Row>
                <Col xs={12}>
                  <div className='paginate-css'>
                    <ReactPaginate
                      previousLabel="<"
                      nextLabel=">"
                      breakLabel="..."
                      pageCount={totalPages}
                      marginPagesDisplayed={1}
                      pageRangeDisplayed={2}
                      onPageChange={({ selected }) => setPage(selected)}
                      containerClassName="pagination"
                      activeClassName="active"
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </main>
          {showAlert && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText="Yes, delete it!"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="secondary"
              title="Are you sure?"
              onConfirm={handleDelete}
              onCancel={() => setShowAlert(false)}
              focusCancelBtn
            >
              This action cannot be undone.
            </SweetAlert>
          )}
          {resetProId && (
            <SweetAlert
              warning
              showCancel
              confirmBtnText="Yes, reset funding"
              confirmBtnBsStyle="danger"
              cancelBtnBsStyle="secondary"
              title="Reset funding for this project?"
              onConfirm={handleResetFunding}
              onCancel={() => setResetProId('')}
              focusCancelBtn
            >
              {resetProStatus === "funding_secured"
                ? "This is a funded deal. It removes the lender, the funding and the assigned transaction coordinator, and returns the project to its original state as if it was never funded. The borrower will need to pay the admin fee again when it is re-funded, and the fee already paid must be refunded or credited manually. Make sure the borrower, lender and transaction coordinator have been informed. Emails and notifications already sent cannot be undone."
                : "This removes the lender and the cancelled funding, and returns the project to its original state as if it was never funded. The lender will need to send a new funding request. Emails and notifications already sent cannot be undone."}
            </SweetAlert>
          )}
        </div>
      </div>
    </>

  )
}
export default ProjectList;